<script>
const serversrc = window.baseConfig.serversrc;
const hospitalCode = window.baseConfig.hospitalCode;

export default {
  serversrc,
  hospitalCode,
};
</script>
